module.exports = __webpack_public_path__ + "static/img/immediately.c54e9c9b.png";